import evite from 'evite';
import Collection from '../collections/collection';
import urls from 'urls';

let intervalId = 0;
const FIVE_MINUTES = 1000 * 60 * 5;
const cache = new Map();
const memoise = new Map();

// TODO - refactor
export default class SearchModel {
  static get TYPE_CATEGORY() { return 'category' };
  static get TYPE_SUGGESTION() { return 'suggestion' };
  static get TYPE_HINT() { return 'hint' };

  categories = [];
  suggestions = [];
  hints = [];

  constructor(attributes){
    Object.assign(this, attributes || {});

    this.categoryCollection = new Collection([], {model: SearchSuggestionModel});
    this.suggestionCollection = new Collection([], {model: SearchSuggestionModel});
    this.hintCollection = new Collection([], {model: SearchSuggestionModel});

    if(!intervalId){
      intervalId = setInterval(function(){
        cache.clear();
      }, FIVE_MINUTES);
    }
  }
  static normalizeSearch(search) {
    if(memoise.has(search)){
      return memoise.get(search);
    }

    const allWhitespaces = /\s+/g;
    const normalizedString = (search || '')
      .trim()
      .toLowerCase()
      .replace(allWhitespaces, ' ');

    memoise.set(search, normalizedString);
    return normalizedString;
  }

  findWhere(options) {
    return (
        options &&
        this.categoryCollection.findWhere(options) ||
        this.suggestionCollection.findWhere(options) ||
        this.hintCollection.findWhere(options) ||
        null
      );
  }

  fetch(search) {
    search = SearchModel.normalizeSearch(search);
    if (!search) {
      return Promise.reject('No search term provided');
    }

    this.search =  search;
    const url = urls.get(this.urlName, { search });

    if(cache.has(search)){
      this.currentFetch = cache.get(search);
    }
    else {
      this.currentFetch = evite.fetch(url, {
          credentials: 'include',
          headers: {
            "X-CSRFToken": evite.cookie("csrftoken"),
            "Accept": "application/json",
            "Content-Type": "application/json"
          }
        })
        .then((response) => {
          if(response.ok){
            return response.json();
          }
          return Promise.reject(response.statusText);
        })
        .then((json) => {
            return Object.assign({ search }, json || {});
        })
        .catch(error => {
          evite.error("Error while posting to " + url + " errorThrown=" + error);
        });
      cache.set(search, this.currentFetch);
    }

    return this.currentFetch;
  }

  async sync(searchOrJson){
    let json;
    if(typeof searchOrJson === 'string'){
      json = await this.fetchSearchTerm(searchOrJson);
    } else {
      json = searchOrJson;
    }

    Object.assign(this, this.parse(json));
    this.categoryCollection.reset(this.categories);
    this.suggestionCollection.reset(this.suggestions);
    this.hintCollection.reset(this.hints);
  }

  parse(json = {}) {
    const parsedJson = Object.assign({}, json);

    parsedJson.search = json.search || '';
    parsedJson.status = json.status || 'unknown';

    const categories = parsedJson.categories = (json.categories || json.category || []).concat();
    const suggestions = parsedJson.suggestions = (json.suggestions || []).concat();
    const hints = parsedJson.hints = (json.hints || []).concat();

    let length = categories.length;
    for(let i = 0; i < length; ++i) {
      const categoryData = categories[i];
      const [text, id] = categoryData;
      categories[i] = new SearchSuggestionModel({id, text, type: SearchModel.TYPE_CATEGORY});
    }

    length = suggestions.length;
    for(let i = 0; i < length; ++i) {
      const suggestionData = suggestions[i];
      let text = '';
      let id = '';

      if (Array.isArray(suggestionData) && suggestionData.length > 1) {
        [text, id] = suggestionData;
      } else {
        id = text = suggestionData;
      }

      suggestions[i] = new SearchSuggestionModel({id, text, type: SearchModel.TYPE_SUGGESTION});
    }

    length = hints.length;
    for(let i = 0; i < length; ++i) {
      const hintData = hints[i];
      const [hint, id] = hintData;
      const text = `${hint} ("${hintId}"?)`;

      hints[i] = new SearchSuggestionModel({id, text, type: SearchModel.TYPE_HINT});
    }

    return parsedJson;
  }
}

class SearchSuggestionModel{
  constructor({ id, text, type }){
    this.id = id || '';
    this.type = type || '';
    this.text = text || '';
  }
}



// WEBPACK FOOTER //
// ./assets/es6/common/models/search_model.es6